import { companyMarginsFeature } from '../reducers/company-margins.reducer';

export const {
  selectCompanyMarginsState,
  selectMargins: selectCompanyMargins,
  selectIsLoading: selectCompanyMarginsIsLoading,
  selectError: selectCompanyMarginsError,
  selectIsSaving: selectCompanyMarginsIsSaving,
  selectSaveError: selectCompanyMarginsSaveError,
} = companyMarginsFeature;
